import React, { useEffect, useState } from "react";
import { ClipboardCheck, Loader2, FileText, Home, Download } from "lucide-react";
import api from "../../lib/api";
import { toast } from "sonner";

const fileUrl = (u) => (u?.startsWith("http") ? u : `${process.env.REACT_APP_BACKEND_URL}${u}`);

export default function MesDocumentsEdl() {
  const [deliveries, setDeliveries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/edl/my-documents").then((r) => setDeliveries(r.data.deliveries || [])).catch(() => toast.error("Chargement impossible")).finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-6" data-testid="mes-documents-page">
      <div className="flex items-center gap-3">
        <div className="w-11 h-11 rounded-2xl bg-brand-lime/30 text-brand-greenDeep flex items-center justify-center"><ClipboardCheck className="w-5 h-5" /></div>
        <div>
          <h2 className="font-display text-2xl font-semibold text-brand-greenDeep">Mes documents d'état des lieux</h2>
          <p className="text-sm text-brand-green/55">Documents de fin de bail transmis par votre bailleur</p>
        </div>
      </div>

      {loading ? (
        <div className="flex items-center justify-center py-24 text-brand-green/50"><Loader2 className="w-7 h-7 animate-spin" /></div>
      ) : deliveries.length === 0 ? (
        <div className="text-center py-20 text-brand-green/50" data-testid="no-documents">Aucun document pour le moment. Vos documents de fin de bail apparaîtront ici une fois la sortie clôturée.</div>
      ) : (
        <div className="space-y-4">
          {deliveries.map((d) => (
            <div key={d.id} className="bg-white rounded-3xl border border-brand-soft p-6" data-testid={`delivery-${d.id}`}>
              <div className="flex items-center gap-2 mb-3">
                <Home className="w-4 h-4 text-brand-green/50" />
                <h3 className="font-display text-lg font-semibold text-brand-greenDeep">{d.property_name || "Bien"}</h3>
                <span className="text-xs text-brand-green/45 ml-auto">{(d.created_at || "").slice(0, 10)}</span>
              </div>
              <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
                {(d.files || []).map((f, i) => (
                  <a key={i} href={fileUrl(f.url)} target="_blank" rel="noreferrer" className="flex items-center gap-2 px-4 py-3 rounded-xl bg-brand-softer hover:bg-brand-mint transition-colors" data-testid={`doc-${d.id}-${i}`}>
                    <FileText className="w-5 h-5 text-brand-greenDeep shrink-0" />
                    <span className="text-sm text-brand-greenDeep flex-1 truncate">{f.name}</span>
                    <Download className="w-4 h-4 text-brand-green/50" />
                  </a>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
